import React, { FC } from 'react'
//
import { CenterAlignmentTemplate } from '../../templates'
import { NotFoundErrorSection } from '../../organisms'

/**
 * Interface
 */

interface NotFoundErrorPagePresenterProps {
  actions: {
    handleHome: () => void
  }
}

/**
 * Presenter
 */

export const NotFoundErrorPagePresenter: FC<NotFoundErrorPagePresenterProps> = props => {
  const {
    actions: { handleHome },
  } = props
  return (
    <CenterAlignmentTemplate>
      <NotFoundErrorSection handleHome={handleHome} />
    </CenterAlignmentTemplate>
  )
}
